import { Component, AfterViewInit, HostListener, ElementRef, Renderer2, Inject } from '@angular/core'
import { DOCUMENT } from '@angular/common'

@Component({
  selector: 'flo-adhesion-footer',
  templateUrl: './adhesion-footer.component.html',
  styleUrls: ['./adhesion-footer.component.scss']
})
export class AdhesionFooterComponent implements AfterViewInit {
  constructor(@Inject(DOCUMENT) private document: Document, private el: ElementRef, private renderer: Renderer2) {}

  private footerEl: HTMLElement | null = null

  ngAfterViewInit() {
    this.footerEl = this.document.getElementById('flo-footer')
    this.adjustPosition()
  }

  @HostListener('window:scroll')
  @HostListener('window:resize')
  onScrollOrResize() {
    this.adjustPosition()
  }

  private adjustPosition() {
    if (!this.footerEl || typeof this.footerEl.getBoundingClientRect !== 'function') return

    const stickyAd: HTMLElement = this.el.nativeElement.querySelector('.adhesion-footer')
    if (!stickyAd) return
    const stickyHeight = stickyAd.offsetHeight
    const footerRect = this.footerEl.getBoundingClientRect()
    const viewportHeight = window.innerHeight

    if (footerRect.top < viewportHeight) {
      const overlap = viewportHeight - footerRect.top
      this.renderer.setStyle(stickyAd, 'transform', `translateY(${Math.min(overlap, stickyHeight)}px)`)
    } else {
      this.renderer.setStyle(stickyAd, 'transform', `translateY(0)`)
    }
  }
}
